// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OjVb","footer":"styles_footer__1hKUe","passCodeTooltip":"styles_passCodeTooltip__2nGFx"};